import React from "react";
import { UseCases } from "@planzone/core";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { useModal } from "@root/client/modal";
import { ContextualMenu } from "@common/contextualMenu";
import { TrashIcon } from "@common/trashIcon";
import { PenIcon } from "@common/penIcon";
import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function CostProfile({ costProfile }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div
      className={classNames(styles.costProfile, {
        [styles.centered]: typeof costProfile.cost === "undefined",
      })}
    >
      <Icon className={styles.icon} />
      <div className={styles.col}>
        <h4 className={styles.name}>{costProfile.name}</h4>
        {typeof costProfile.cost !== "undefined" && (
          <p className={styles.cost}>
            {costProfile.cost} € / <AllocationUnit format="text" />
          </p>
        )}
      </div>
      <div className={styles.contextualMenu}>
        <ContextualMenu
          items={[
            {
              name: t("costProfilesPage.sidebar.edit"),
              renderIcon: (className) => <PenIcon className={className} />,
              act: () =>
                pushView({
                  key: UseCases.editCostProfile,
                  data: costProfile,
                }),
            },
            {
              name: t("costProfilesPage.sidebar.remove"),
              color: "#db5f63",
              renderIcon: (className) => (
                <TrashIcon
                  className={classNames(className, styles.removeIcon)}
                />
              ),
              act: () =>
                pushView({
                  key: UseCases.removeCostProfile,
                  data: costProfile,
                }),
            },
          ]}
        />
      </div>
    </div>
  );
}

export { CostProfile };
